import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showLoginModal: false,
  OTPRequested: false,
  user: { user_id: "", email: "", token: "" },
  showCTAModal: false,
  showCallToCTA: false,
  emailVerified: false,
  isFirstTimeUser: false,
  cartItems: [],
  prodCartItems: [],
  uatOrders: [],
  prodOrders: [],
  liveOrders:[],
  wishListedItems: [],
  access: {
    hasUATAccess: false,
    hasProdAccess: false,
  },
  primaryUser: false,
  canAddUsers: false,
  uatKey: "",
  prodKey: "",
  redirectionUrl: ''
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    setShowLoginModal: (state, action) => {
      state.showLoginModal = action.payload;
    },
    setRedirectionUrl: (state, action) => {
      state.redirectionUrl = action.payload;
    },
    setOTPRequested: (state, action) => {
      state.OTPRequested = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setShowCTAModal: (state, action) => {
      state.showCTAModal = action.payload;
    },
    setShowCallToCTA: (state, action) => {
      state.showCallToCTA = action.payload;
    },
    setEmailVerification: (state, action) => {
      state.emailVerified = action.payload;
    },
    setFirstTimeUser: (state, action) => {
      state.isFirstTimeUser = action.payload;
    },
    setUserCartItems: (state, action) => {
      state.cartItems = action.payload;
    },
    setUserProdCartItems: (state, action) => {
      state.prodCartItems = action.payload;
    },
    setWishListedItems: (state, action) => {
      state.wishListedItems = action.payload;
    },
    setUATOrders: (state, action) => {
      state.uatOrders = action.payload;
    },
    setProdOrders: (state, action) => {
      state.prodOrders = action.payload;
    },
    setLiveOrders: (state, action) => {
      state.liveOrders = action.payload;
    },
    setAccess: (state, action) => {
      state.access = action.payload;
    },
    setPrimaryUser: (state, action) => {
      state.primaryUser = action.payload;
    },
    setCanAddUsers: (state, action) => {
      state.canAddUsers = action.payload;
    },
    setKeys: (state, action) => {
      state.uatKey = action.payload?.uatKey || "";
      state.prodKey = action.payload?.prodKey || "";
    },
  },
});

export const {
  setShowLoginModal,
  setOTPRequested,
  setUser,
  setShowCTAModal,
  setShowCallToCTA,
  setEmailVerification,
  setFirstTimeUser,
  setUserProdCartItems,
  setUserCartItems,
  setWishListedItems,
  setUATOrders,
  setProdOrders,
  setLiveOrders,
  setAccess,
  setPrimaryUser,
  setCanAddUsers,
  setKeys,
  setRedirectionUrl
} = authenticationSlice.actions;
export default authenticationSlice.reducer;
